import * as React from "react";

function Minus(props) {
  return (
    <svg viewBox="0 0 512 512" width="1em" height="1em" {...props}>
      <path
        d="M256 0C115.3 0 0 115.3 0 256s115.3 256 256 256 256-115.3 256-256S396.7 0 256 0z"
        fill="#ff3636"
      />
      <path
        d="M512 256c0 140.7-115.3 256-256 256V0c140.7 0 256 115.3 256 256z"
        fill="#f40000"
      />
      <path fill="#e7e7e7" d="M106 226h300v60H106z" />
      <path fill="#d3d3d8" d="M256 226h150v60H256z" />
    </svg>
  );
}

const MemoMinus = React.memo(Minus);
export default MemoMinus;
